import CryptoJS from 'crypto-js'

const AES_PASSWORD = 'CHANEL_VIA_2024!@#$'

/**
 * AES 加密（与后端 encryptForFrontend 方法对应）
 * @param {string} content - 待加密内容
 * @param {string} aesPassword - 密钥
 * @returns {string|null} Base64 编码的加密数据
 */
export function encryptAES(content, aesPassword = AES_PASSWORD) {
    try {
        const key = CryptoJS.SHA256(aesPassword)
        const text = typeof content === 'object' && content !== null 
            ? JSON.stringify(content) 
            : String(content);
        
        const encrypted = CryptoJS.AES.encrypt(text, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        
        return encrypted.toString();
    } catch (error) {
        console.error('加密失败：', error);
        return null;
    }
}

/**
 * AES 解密（与后端 decryptFromFrontend 方法对应）
 * @param {string} encryptedContent - Base64 编码的加密数据
 * @param {string} aesPassword - 密钥
 * @returns {string|null} 解密后的原始数据
 */
export function decryptAES(encryptedContent, aesPassword = AES_PASSWORD) {
    try {
        const key = CryptoJS.SHA256(aesPassword)
        
        const decrypted = CryptoJS.AES.decrypt(encryptedContent, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        console.error('解密失败：', error);
        return null;
    }
}
